import { Component, type ErrorInfo, type ReactNode } from 'react';

import { Button, ErrorState } from '@/shared/ui/index.js';

interface Props {
  readonly children: ReactNode;
}
interface State {
  readonly hasError: boolean;
}

/**
 * Última red de seguridad de la UI: un error de render no deja la pantalla en
 * blanco. No expone el detalle técnico al usuario, solo lo registra.
 */
export class AppErrorBoundary extends Component<Props, State> {
  public override state: State = { hasError: false };

  public static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  public override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Error no controlado en la interfaz', error, info.componentStack);
  }

  public override render(): ReactNode {
    if (!this.state.hasError) {
      return this.props.children;
    }
    return (
      <ErrorState
        action={
          <Button
            onClick={() => {
              globalThis.location.reload();
            }}
          >
            Recargar
          </Button>
        }
        message="La página tuvo un problema. Recargar suele resolverlo."
        title="Algo salió mal"
      />
    );
  }
}
